
import { AVIS_INTRODUCCIO_INSERIR_EN_CURS,
         AVIS_INTRODUCCIO_INSERIR_FINALITZADA,
         AVIS_INICIALITZAR } from '../../../actions/actionTypes';

const ESTAT_INICIAL = false;

const peticioInserirEnCurs = (state = ESTAT_INICIAL, action) => {

    switch (action.type) {
        case AVIS_INTRODUCCIO_INSERIR_EN_CURS:
            return true;
        case AVIS_INTRODUCCIO_INSERIR_FINALITZADA:
            return false;
        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL;
        default:
            return state;
    }
};

export default peticioInserirEnCurs;



// WEBPACK FOOTER //
// ./src/reducers/avis/formulari/peticioInserirEnCurs.js